// Chicken Road API ke response ko ek jaisa shape dene wale helpers

// /active ya /start ya /history ka ek round -> { gameId, difficulty, betAmount, currentStep, status }
export function normalizeRound(raw) {
  const r = Array.isArray(raw) ? raw.find((x) => x?.status === 'ACTIVE') : raw?.game || raw?.round || raw;
  if (!r || !r.gameId) return null;
  return {
    gameId: r.gameId,
    difficulty: r.difficulty,
    betAmount: Number(r.betAmount) || 0,
    currentStep: Number(r.currentStep ?? r.steps) || 0,
    status: r.status || 'ACTIVE',
  };
}

// outcome: cashed | burnt | active | refunded
export function outcomeOf(status) {
  if (status === 'CASHED_OUT') return 'cashed';
  if (status === 'ACTIVE') return 'active';
  if (status === 'REFUNDED') return 'refunded';
  return 'burnt';
}

// GET /chicken/history ka ek row -> UI row
export function normalizeBet(r) {
  return {
    id: r.gameId,
    createdAt: r.createdAt,
    difficulty: r.difficulty || '',
    bet: Number(r.betAmount) || 0,
    win: Number(r.winAmount) || 0,
    multiplier: Number(r.cashoutMultiplier) || 0,
    steps: Number(r.steps) || 0,
    status: r.status,
    outcome: outcomeOf(r.status),
  };
}
